import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'app-modal-selector',
  templateUrl: './modal-selector.component.html',
  styleUrls: ['./modal-selector.component.scss'],
  standalone: false
})
export class ModalSelectorComponent implements OnInit {

  @Input() searchText: string = 'COMMON.SEARCH';
  @Input() cancelText: string = 'COMMON.CANCEL';
  @Input() resetText: string = 'COMMON.CLEAN';
  @Input() closeText: string = 'COMMON.CLOSE';
  @Input() doneText: string = 'COMMON.SAVE';

  @Input() title: string = '';

  @Input() items: any[] = [];
  @Input() itemsValueField: string = 'id';
  @Input() itemsLabelField: string = 'nombre';
  @Input() itemsImageField: string = '';
  @Input() itemsDescriptionField: string = '';

  @Input() groupItems: boolean = false;
  @Input() groupValueField: string = 'id';
  @Input() groupTextField: string = 'nombre';

  @Input() value: any = null;

  @Input() multiple: boolean = false;
  @Input() disabledReset: boolean = false;

  itemsGroupToList: any[] = [];
  itemsToList: any[] = [];

  searchValue: string = '';

  constructor(
    protected modalCtrl: ModalController
  ) {
  }

  ngOnInit() {
    this.setValues();

    if (this.groupItems) {
      this.setGroupItems();
    }
  }


  /**
   * Agrupar items
   *
   */
  setGroupItems() {
    const groupMap = new Map();

    this.items.forEach(item => {
      const groupId = item[this.groupValueField];
      const groupText = item[this.groupTextField];

      if (!groupMap.has(groupId)) {
        groupMap.set(groupId, {id: groupId, text: groupText, items: []});
      }

      groupMap.get(groupId).items.push(item);
    });

    this.itemsGroupToList = Array.from(groupMap.values());
  }


  /**
   * Establecer valores
   *
   */
  setValues() {

    if (this.items) {
      this.itemsToList = this.items;
    }

    if (this.multiple) {
      this.setValuesWhenMultiple();
      return;
    }

    this.setValuesWhenNotMultiple();
  }


  /**
   * Establecer valor cuando es múltiple
   *
   */
  setValuesWhenMultiple() {

    if (!this.itemsToList) {
      return;
    }

    const selectedValues: any[] = Array.isArray(this.value) ? this.value : [];

    this.itemsToList.forEach((item) => {
      item.is_checked = selectedValues.includes(item[this.itemsValueField]);
    });
  }


  /**
   * Establecer valor cuando es único
   *
   */
  setValuesWhenNotMultiple() {

    if (!this.itemsToList) {
      return;
    }

    this.itemsToList.forEach((item) => {
      item.is_checked = item[this.itemsValueField] === this.value;
    });
  }


  /**
   * Acción de seleccionar un item
   *
   */
  doCheckAction(item: any) {

    if (this.multiple) {
      this.doCheckActionWhenMultiple();
      return;
    }

    this.doCheckActionNotMultiple(item);
  }


  /**
   * Seleccionar múltiples items
   *
   */
  doCheckActionWhenMultiple() {
    this.value = this.itemsToList
      .filter((item) => item.is_checked)
      .map((item) => item[this.itemsValueField]);
  }


  /**
   * Seleccionar un item único
   *
   */
  doCheckActionNotMultiple(itemSelected: any) {

    if (!this.disabledReset && !itemSelected.is_checked) {
      this.resetCheck();
      return;
    }

    itemSelected.is_checked = true;

    this.itemsToList.forEach((item) => {
      item.is_checked = item[this.itemsValueField] === itemSelected[this.itemsValueField];
    });

    this.value = itemSelected[this.itemsValueField];
    this.dismiss(this.value);
  }


  /**
   * Resetear selección
   *
   */
  resetCheck() {
    this.itemsToList.forEach((item) => (item.is_checked = false));
    this.value = null;

    this.dismiss(this.value, 'reset');
  }


  /**
   * Cerrar vista modal
   *
   */
  dismiss(data?: any, role?: string) {
    setTimeout(() => {
      this.modalCtrl.dismiss(data, role);
    }, 100);
  }

}
